'use client';
import { useMediaQuery } from '../useMediaQuery/useMediaQuery.js';

const useReducedMotion = (options)=>useMediaQuery('(prefers-reduced-motion: reduce)', options)[0];

export { useReducedMotion };
//# sourceMappingURL=useReducedMotion.js.map
